import { useSearchParams } from "next/navigation";
import { useEffect, useMemo } from "react";
import { useAppLayerContext } from "@/shared/contexts/AppLayer";
import { UIUtils } from "@/shared/utils/UIUtils";

interface DevToolsParams {
    verifyEmailParam?: string;
    finalizeTimeoutParam?: string;
}

interface UseDevToolsParamsProps {
    config?: DevToolsParams;
}

interface UseDevToolsParamsReturn {
    hasEmailRegisterCheckParam: boolean;
    hasFinalizeTimeoutParam: boolean;
}

export function useDevToolsParams({ config }: UseDevToolsParamsProps = {}): UseDevToolsParamsReturn {
    const searchParams = useSearchParams();
    const { updateAppState } = useAppLayerContext();

    // Email register check param
    const hasEmailRegisterCheckParam = useMemo(() => {
        const _emailRegisterCheck = UIUtils.getCaseInsensitiveValue(new URLSearchParams(searchParams.toString()), config?.verifyEmailParam ?? "verifyMC");
        return _emailRegisterCheck === "true";
    }, [searchParams, config?.verifyEmailParam]);

    // Finalize timeout param
    const hasFinalizeTimeoutParam = useMemo(() => {
        return !!UIUtils.getCaseInsensitiveValue(new URLSearchParams(searchParams.toString()), config?.finalizeTimeoutParam ?? "devFinalizeTimeout");
    }, [searchParams, config?.finalizeTimeoutParam]);

    // Sync with AppLayer
    useEffect(() => {
        if (hasEmailRegisterCheckParam) {
            updateAppState({ devIsEmailRegisterCheckEnabled: true });
        }
    }, [hasEmailRegisterCheckParam, updateAppState]);

    return {
        hasEmailRegisterCheckParam,
        hasFinalizeTimeoutParam
    };
}
